import { createStore } from 'vuex';
export default createStore({
    state: {
        currentTenant: null,
    },
    mutations: {},
    actions: {},
    modules: {},
});
